import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'
import * as sdk from '@cypro/server/sdk'

type Input = sdk.GetPatientsCountData['query']

export function getPatientsCountQueryOptions(input: Input) {
  return queryOptions({
    queryKey: ['patients-count', input],
    queryFn: async () => {
      const {data} = await sdk.getPatientsCount({query: input})
      return data?.count || 0
    },
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })
}

export function useGetPatientsCount(input: Input) {
  const {data, ...rest} = useQuery({
    ...getPatientsCountQueryOptions(input),
  })

  return {...rest, patientsCount: data}
}
